export default {
  YMETRIKA_NUMBER: process.env.VUE_APP_YMETRIKA_NUMBER || '88059946',
};
